import { PSTFieldNames } from '@common/data-models/fields/pst-field-names';
import { ViewStateOptions } from '@common/data-models/navigation/viewstate-options';
import { ViewStateOptionsSerializer } from '@common/data-models/serializers/serializers';
import { ViewStateTypes } from '@common/enums/viewstate-types';

import { Record } from './record';
import { SingleFeedViewStateRecord } from './single-feed-viewstate-record';

export class WireViewStateRecord extends SingleFeedViewStateRecord {
    public initialize() {
        super.initialize();
        this.viewStateType = ViewStateTypes.WIRE;
        this.viewStateLayout = ViewStateOptionsSerializer.Instance(Record.globalTablesService).initialize(this.viewStateType, PSTFieldNames.PSTViewStateLayout);
    }

    public get viewStateLayout(): ViewStateOptions {
        return this.getAs<ViewStateOptions>('PSTViewStateLayout');
    }
    public set viewStateLayout(value: ViewStateOptions) {
        this.set('PSTViewStateLayout', value);
    }

    public get viewStateFeedNames(): string[] {
        return this.getAs<string[]>(PSTFieldNames.PSTViewStateTwitterFeedNames);
    }
    public set viewStateFeedNames(value: string[]) {
        this.set(PSTFieldNames.PSTViewStateTwitterFeedNames, value);
    }

    public get viewStateScope(): number {
        return this.getAs<number>(PSTFieldNames.PSTViewStateFeedScope);
    }
    public set viewStateScope(value: number) {
        this.set(PSTFieldNames.PSTViewStateFeedScope, value);
    }
}
